import { authReducer } from "./auth";
import { projectsReducer } from "./projects";
import { userReducer } from "./user";
import { combineReducers } from "redux";
import { fetchDataReducer } from "./fetchData";
import { manualReducer } from "./manualdata";
import { pcpSelectionReducer } from "./pcpSelection";

const rootReducer = combineReducers({
  auth: authReducer,
  projects: projectsReducer,
  users: userReducer,
  manualData: manualReducer,
  pcpSelection: pcpSelectionReducer,
  fetchData: fetchDataReducer,
});

export default rootReducer;
/* will add persist configs here */
